import { useEffect, useRef, useState } from 'react'
import { IoIosArrowForward, IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { useSelector } from 'react-redux'

const EXTRA_POINTS_CONTENT = [
  {
    "title": "Technical Support",
    "points": [
      "Access to a dedicated technical support team ensures uninterrupted progress in your learning and project work by promptly addressing your queries.",
      "Customized assistance from experienced technicians who can guide you through complex challenges, from troubleshooting to advanced problem-solving techniques.",
      "Comprehensive resources including detailed FAQs, how-to guides, and interactive webinars, tailored to enhance your understanding and application of technical concepts."
    ]
  },
  {
    "title": "Industry Immersions",
    "points": [
      "Participate in speaker sessions led by worldwide industry leaders, offering direct exposure to innovative strategies and experiences.",
      "Harness practical insights from these talks to sharpen your competitive edge in the intense industry landscape.",
      "Stay informed on the latest industry trends, ensuring you remain relevant and ahead in your field.",
      "Experience deep industry immersion, enriching your understanding and preparing you for real-world challenges and opportunities."
    ]
  },
  {
    "title": "Placement Assistance",
    "points": [
      "Comprehensive Support by Accredian: The Career Launchpad program offers targeted, efficient guidance to help participants secure rewarding job opportunities.",
      "Resume Crafting Sessions by Accredian: Participants receive expert guidance on crafting resumes that emphasize key achievements, relevant experiences, and unique skills, enhancing interview prospects.",
      "LinkedIn Optimization Sessions by Accredian: Personalized sessions focus on enhancing LinkedIn profiles with strategic keywords to attract recruiters and networking opportunities.",
      "Intensive Interview Preparation by Accredian: Includes role-play scenarios and strategies, equipping participants to confidently handle diverse interview formats and questions."
    ]
  },
  {
    "title": "Learning Hub",
    "points": [
      "Enjoy access to a comprehensive range of resources, content, and community support.",
      "Access regularly updated study materials, research papers, and cutting-edge tools.",
      "Explore a diverse array of educational content, including tutorials, webinars, and case studies.",
      "Engage with peers, experts, and alumni for collaboration, networking, and ongoing learning."
    ]
  }
]

const ExtraPoints = () => {

  const { data } = useSelector(state => state.program)
  const [activeTab, setActiveTab] = useState("Technical Support")
  const [points, setPoints] = useState([])
  const [isScrolled, setIsScrolled] = useState(false);

  const handleOverviewData = (data) => {
    const { title, points } = data
    setActiveTab(title)
    setPoints(points)
  }

  useEffect(() => {
    setPoints(EXTRA_POINTS_CONTENT[0].points)
  }, [])

  const scrollContainer = useRef(null);

  const handlePreviousButt = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollLeft -= 200;
    }
  }

  const handleNextButt = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollLeft += 200;
    }
  }

  useEffect(() => {
    const checkScroll = () => {
      if (scrollContainer.current) {
        setIsScrolled(scrollContainer.current.scrollLeft > 0);
        // setIsEnd(scrollContainer.current.scrollLeft + scrollContainer.current.clientWidth >= scrollContainer.current.scrollWidth);
      }
    };

    checkScroll();
    scrollContainer.current.addEventListener('scroll', checkScroll);

    return () => {
      if (scrollContainer.current) {
        scrollContainer.current.removeEventListener('scroll', checkScroll);
      }
    };
  }, []);

  return (
    <div id="extra achievements" className="w-full flex justify-center xl:px-12 px-4 py-12">
      <div className="w-full max-w-[85rem]">
        <div className="w-full md:text-start text-center">
          <h4 className="text-base font-medium">What added benefits does this program offer?</h4>
          <h1 className='text-2xl md:text-3xl mt-2 font-semibold capitalize'><span className='text-universal'>Additional</span> Program Resources</h1>
        </div>
        <div className="flex gap-4 mt-8 md:mt-12 md:flex-row flex-col">
          <div className="w-full md:flex-[0.3] relative">
            {/* previous */}
            {isScrolled && (
              <button onClick={handlePreviousButt} className='absolute md:hidden block z-20 left-0 top-[50%] translate-y-[-50%] drop-shadow-lg border bg-white rounded-full p-1 rotate-180'>
                <IoIosArrowForward />
              </button>
            )}
            <div ref={scrollContainer} className="no-scrollbar md:max-w-sm md:px-4 py-2 flex flex-row md:flex-col items-center gap-4 md:gap-6 max-w-[90vw] overflow-x-auto">
              {/* {data?.extra_points && data?.extra_points.content.map((val, index) => {
                return (
                  <div onClick={() => handleOverviewData(val)} key={index} className={`w-full max-w-[280px] rounded-md ${activeTab === val.title ? "drop-shadow-xl bg-white border" : "border border-neutral-300"} px-4 py-4 text-center cursor-pointer`}>
                    <h1 className={`text-sm max-md:text-nowrap lg:text-lg font-semibold ${activeTab === val.title ? " text-universal" : "text-neutral-500"} capitalize`}>
                      {val.title}
                    </h1>
                  </div>
                )
              })} */}
              {data?.extra_points && EXTRA_POINTS_CONTENT?.map((val, index) => {
                const section = Array.isArray(data?.extra_points) && data?.extra_points?.includes(val.title);
                if (!section) return null
                return (
                  <div
                    onClick={() => handleOverviewData(val)}
                    key={index}
                    className={`w-full max-w-[280px] rounded-md ${activeTab === val.title ? "drop-shadow-xl bg-white border" : "border border-neutral-300"} px-4 py-3 lg:py-4 text-center cursor-pointer`}
                  >
                    <h1 className={`text-xs max-md:text-nowrap lg:text-lg font-semibold ${activeTab === val.title ? " text-universal" : "text-neutral-500"} capitalize`}>
                      {val.title}
                    </h1>
                  </div>
                );
              })}
            </div>
            {/* next */}
            <button onClick={handleNextButt} className='absolute md:hidden block z-20 right-0 top-[50%] translate-y-[-50%] drop-shadow-lg border bg-white rounded-full p-1'>
              <IoIosArrowForward />
            </button>
          </div>
          <div className="w-full md:flex-[0.7] px-4 flex flex-col items-start">
            <div className="w-full md:w-fit flex flex-col gap-4 mt-2">
              {points?.map((point, index) => (
                <div key={index} className="w-full flex gap-2 max-w-3xl">
                  <div className='w-5 lg:w-6 h-5 lg:h-6 flex-shrink-0 mt-[2px]'>
                    <IoMdCheckmarkCircleOutline className='w-full h-full text-green-500' />
                  </div>
                  <h1 className="text-sm lg:text-lg font-medium">{point}</h1>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExtraPoints